import * as React from 'react';
import { connect } from 'react-redux';

import IState from '../../../../interfaces/states';

import { Customer as CustomerAction } from '../../../../actions'

import Widget from './Widget';
import LoadingCircle from '../../../loading/Circle';

import RemoteDataUtil from '../../util/RemoteDataUtil';

import ISettings from './ISettings';
import { IReportSettings } from '../../../../interfaces';

interface IWidgetData {
    customer,
}

interface IProps {
    widgetId: string,
    widgetData: IWidgetData,
    settings: ISettings,
    reportSettings: IReportSettings,
    getCustomer: Function,
}

class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
        widgetData: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object,
        reportSettings: React.PropTypes.object.isRequired,
        getCustomer: React.PropTypes.func.isRequired,
    };

    fetchBaseData(props: IProps) {
        const { getCustomer, widgetId, reportSettings } = props;

        if (reportSettings.customerId) {
            getCustomer(
                widgetId,
                reportSettings.customerId,
            );
        }
    }

    componentDidMount() {
        this.fetchBaseData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const { reportSettings } = this.props;
        if (reportSettings !== nextProps.reportSettings) {
            this.fetchBaseData(nextProps);
        }
    }

    renderLoading() {
        return (
            <LoadingCircle size="xxl" name={this.props.widgetId} infinite />
        );
    }

    renderError(error: string) {
        return (
            <div>
                <h1>Error</h1>
                <pre>{error}</pre>
            </div>
        );
    }

    render() {
        const { widgetData, settings, reportSettings } = this.props;
        let customer = widgetData.customer || { data: {} };


        if (RemoteDataUtil.isLoading([widgetData.customer])) {
            return this.renderLoading();
        }

        if (RemoteDataUtil.isError([widgetData.customer])) {
            return this.renderError(RemoteDataUtil.getErrorMessage([widgetData.customer]));
        }

        return (
            <Widget customer={customer.data} settings={settings} reportSettings={reportSettings} />
        );
    }
}

const mapStateToProps = (state: IState, props: IProps) => ({
    widgetData: state.widgetData[props.widgetId] || { customer: null },
    reportSettings: state.reportSettings,
    settings: (state.reportTemplate.byId[props.widgetId] || {}).settings,
});

export default connect(
    mapStateToProps,
    {
        getCustomer: CustomerAction.getCustomer
    }
)(WidgetContainer);


// WEBPACK FOOTER //
// ./src/components/widget/basic/title/WidgetContainer.tsx